import { render } from "./cardProject.vue?vue&type=template&id=4437fe5a&scoped=true"
import script from "./cardProject.vue?vue&type=script&lang=js"
export * from "./cardProject.vue?vue&type=script&lang=js"

import "./cardProject.vue?vue&type=style&index=0&id=4437fe5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4437fe5a"]])

export default __exports__